module.exports = __webpack_public_path__ + "static/img/share41.232c825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result/41/share41.png
// module id = /sjt
// module chunks = 0